import { combineReducers } from '@reduxjs/toolkit';
import getSystemApiModuleListReducer from './get-system-api-module-list';
import syncSystemApiModuleListReducer from './sync-system-api-module-list';

const systemApiModuleReducer = combineReducers({
  getSystemApiModuleList: getSystemApiModuleListReducer,
  syncSystemApiModuleList: syncSystemApiModuleListReducer
});

export default systemApiModuleReducer;